import { Link } from "react-router-dom";
import "./SiteHeader.scss";

const NAV_ITEMS = [
  { hash: "skupiny", label: "Pre skupiny" },
  { hash: "ubytovanie", label: "Ubytovanie" },
  { hash: "cennik", label: "Cenník" },
  { hash: "areal", label: "Areál" },
  { hash: "okolie", label: "Okolie" },
  { hash: "kontakt", label: "Kontakt" },
];

// Hlavička podľa návrhu triferis-landing: logo, kotvy na sekcie homepage a tlačidlo na dopyt.
// Pôvodná hlavička s prihlásením a registráciou ostáva v components/Header (nie je pripojená).
function SiteHeader() {
  return (
    <header className="site-header">
      <div className="site-header__wrap">
        <Link
          to="/"
          className="site-header__logo"
          aria-label="Penzión Triferis"
          onClick={() => window.scrollTo(0, 0)}
        >
          <img
            src="/pictures/triferis/triferis-logo-horizontal.svg"
            alt="Penzión Triferis"
            className="site-header__logo-img"
          />
        </Link>

        <nav className="site-header__nav" aria-label="Hlavná navigácia">
          {NAV_ITEMS.map((item) => (
            <Link key={item.hash} to={`/#${item.hash}`} className="site-header__link">
              {item.label}
            </Link>
          ))}
          <Link to="/#kontakt" className="site-header__cta">
            Rezervovať pobyt
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default SiteHeader;
